var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5464 14.8214C11.7938 15.0595 12.2062 15.0595 12.4536 14.8214L17.8144 9.68715C18.0619 9.4225 18.0619 9.02552 17.8144 8.78733L17.1821 8.17864C16.9347 7.94045 16.5223 7.94045 16.2474 8.17864L12.0137 12.2543L7.75258 8.17864C7.47766 7.94045 7.06529 7.94045 6.81787 8.17864L6.18557 8.78733C5.93814 9.02552 5.93814 9.4225 6.18557 9.68715L11.5464 14.8214Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.985028835d426282af7c2bf490b6c71e.svg";
export { ForwardRef as ReactComponent };